// @core/api/endpoints/license/input_license_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  InputLicenseKeyRequest,
  LicenseResponse,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Input license key
 * Manually input a new license key for air-gapped environments where online activation is not possible. The key is verified offline using the embedded public key.
 */
export async function InputLicenseKey(
  data: InputLicenseKeyRequest,
  options?: RequestOptions
): Promise<LicenseResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/licenses/input-key`;
  const requestOptions = options;
  return client.post<LicenseResponse>(requestPath, data, requestOptions);
}
